var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ion-item',[_c('ion-label',{attrs:{"position":"stacked"}},[_vm._v(" "+_vm._s(_vm.$t(_vm.field.label))+" ")]),_c('ion-toggle',{attrs:{"checked":_vm.toggled},on:{"ionChange":_vm.toggleChanged}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }